import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setLayoutModalInfo } from 'core/templates/actions'
import Congratulations from './Congratulations'

const mapStateToProps = state => ({
  wizards: state.wizards,
  vehicleTradeIn: state.tradeIn.vehicle,
  vehicle: state.layout.vehicle
})

const mapDispatchToProps = {
  setWizards,
  setLayoutModalInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(Congratulations)
